"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuadraticClient = exports.DEFAULT_COEFFICIENTS = exports.QUADRATIC_PLUGIN_ID = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
const quadratic_1 = require("./quadratic");
const Client_1 = require("../common/Client");
exports.QUADRATIC_PLUGIN_ID = new web3_js_1.PublicKey('quadCSapU8nTdLg73KHDnmdxKnJQsh7GUbu5tZfnRRr');
const toAnchorType = (coefficients) => ({
    a: coefficients[0],
    b: coefficients[1],
    c: coefficients[2],
});
// By default, the quadratic plugin will use a function ax-2 + bx - c
// resulting in a vote weight that is the square root of the token balance
exports.DEFAULT_COEFFICIENTS = [1, 0, 0];
class QuadraticClient extends Client_1.Client {
    constructor(program, devnet, governanceProgramId = Client_1.DEFAULT_GOVERNANCE_PROGRAM_ID) {
        super(program, devnet);
        this.program = program;
        this.devnet = devnet;
        this.governanceProgramId = governanceProgramId;
        this.requiresInputVoterWeight = true;
    }
    static connect(provider, devnet) {
        return __awaiter(this, void 0, void 0, function* () {
            return new QuadraticClient(new anchor_1.Program(quadratic_1.IDL, exports.QUADRATIC_PLUGIN_ID, provider), devnet);
        });
    }
    configureRegistrar(realm, mint, previousVoterWeightPluginProgramId, coefficients = exports.DEFAULT_COEFFICIENTS) {
        return __awaiter(this, void 0, void 0, function* () {
            const { registrar, registrarBump } = this.getRegistrarPDA(realm, mint);
            const methodsBuilder = this.program.methods
                .configureRegistrar(toAnchorType(coefficients), !!previousVoterWeightPluginProgramId)
                .accounts({
                registrar,
                realm,
                realmAuthority: this.program.provider.publicKey,
            });
            if (previousVoterWeightPluginProgramId) {
                methodsBuilder.remainingAccounts([{
                        pubkey: previousVoterWeightPluginProgramId,
                        isSigner: false,
                        isWritable: false
                    }]);
            }
            return methodsBuilder
                .instruction();
        });
    }
    calculateVoterWeight(voter, realm, mint, inputVoterWeight) {
        return __awaiter(this, void 0, void 0, function* () {
            const registrar = yield this.getRegistrarAccount(realm, mint);
            // No registrar yet, QV weight cannot be calculated
            if (!registrar)
                return null;
            const coefficients = registrar.quadraticCoefficients;
            // otherwise, the input voter weight is passed through
            return QuadraticClient.applyCoefficients(inputVoterWeight, QuadraticClient.convertCoefficientsFromAnchorType(coefficients));
        });
    }
    static convertCoefficientsFromAnchorType(coefficients) {
        return [coefficients.a, coefficients.b, coefficients.c];
    }
    static applyCoefficients(inputVoterWeight, coefficients) {
        const [a, b, c] = coefficients;
        const number = inputVoterWeight.toNumber();
        const rootX = Math.sqrt(inputVoterWeight.toNumber());
        return new anchor_1.BN(Math.floor(a * rootX + b * number + c));
    }
    createVoterWeightRecord(voter, realm, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const { registrar } = this.getRegistrarPDA(realm, mint);
            const { voterWeightPk } = this.getVoterWeightRecordPDA(realm, mint, voter);
            return this.program.methods
                .createVoterWeightRecord(voter)
                .accounts({
                registrar,
                voterWeightRecord: voterWeightPk,
            })
                .instruction();
        });
    }
    createMaxVoterWeightRecord(realm, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    updateVoterWeightRecord(voter, realm, mint, action, inputRecordCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            const { registrar } = this.getRegistrarPDA(realm, mint);
            const { voterWeightPk } = this.getVoterWeightRecordPDA(realm, mint, voter);
            const inputVoterWeightPk = yield this.getPredecessorVoterWeightRecordPDA(realm, mint, voter, inputRecordCallback);
            const ix = yield this.program.methods
                .updateVoterWeightRecord()
                .accounts({
                registrar,
                inputVoterWeight: inputVoterWeightPk,
                voterWeightRecord: voterWeightPk,
            })
                .instruction();
            return { pre: [ix] };
        });
    }
    updateMaxVoterWeightRecord(realm, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
}
exports.QuadraticClient = QuadraticClient;
//# sourceMappingURL=client.js.map